import { Card, Col, Flex, List, Tag } from "antd";
import React from "react";

export default function HomeDivCard({
  title,
  data,
  isLoading,
  group,
  cardKey,
  icon,
}) {
  const getSuffix = () => {
    if (group === "occupation") {
      return "min";
    } else if (group === "revenue") {
      return "R$";
    } else if (group === "revenue_per_hour") {
      return "R$/h";
    }
  };
  return (
    <Col xs={24} md={12}>
      <Card
        size="small"
        title={title}
        style={{
          height: "100%",
          textAlign: "center",
        }}
        styles={{
          header: {
            fontWeight: 450,
            backgroundColor: "#d0d6e2",
          },
          body: {
            padding: "0 12px",
          },
        }}
        loading={isLoading}>
        <List
          itemLayout="horizontal"
          style={{
            textAlign: "left",
          }}
          dataSource={data}
          loading={isLoading}
          renderItem={(item) => (
            <List.Item style={{ padding: 16 }}>
              <List.Item.Meta
                avatar={icon}
                description={
                  <Flex style={{ color: "black" }}>
                    <span
                      style={{
                        display: "flex",
                        flex: 1,
                        justifyContent: "space-between",
                        alignItems: "center",
                        gap: 8,
                      }}>
                      <strong style={{ whiteSpace: "normal", flex: 1 }}>
                        {item.description}
                      </strong>
                      <Tag
                        color={
                          cardKey === "first_zones" ||
                          cardKey === "first_collections"
                            ? "green"
                            : "red"
                        }
                        style={{
                          whiteSpace: "nowrap",
                          display: "flex",
                          flexDirection:
                            group === "revenue" ? "row-reverse" : "row",
                        }}>
                        <span
                          style={{
                            padding:
                              group === "revenue" ? "0 0 0 4px" : "0 4px 0 0",
                          }}>
                          {group === "revenue" || group === "revenue_per_hour"
                            ? item.value.toLocaleString("pt-BR", {
                                maximumFractionDigits: 2,
                              })
                            : item.value.toFixed(1)}
                        </span>
                        <span>{getSuffix()}</span>
                      </Tag>
                    </span>
                  </Flex>
                }
              />
            </List.Item>
          )}
        />
      </Card>
    </Col>
  );
}
